﻿window.svgFontAwesomeData64 = {}
window.cImage = function (bddRef) {
    var Me = this;

    this.mSvgfontAwesomeToData64 = function (namesvg, size, outputFormat, funcOk) {
        if (typeof svgFontAwesomeData64[namesvg + "_" + size.toString()] == 'undefined') {
            var htmlImg = $("<img style='height:" + size + "px;'/>")
            htmlImg[0].crossOrigin = 'Anonymous';
            htmlImg.on("load", function () {
                var canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                canvas.height = size;
                canvas.width = size;
                ctx.drawImage(this, 0, 0);
                var dataURL = canvas.toDataURL(outputFormat);
                svgFontAwesomeData64[namesvg + "_" + size.toString()] = dataURL;
                if (typeof funcOk != 'undefined') funcOk(dataURL)
            })
            htmlImg[0].src = ((typeof parametre != 'undefined') ? parametre.urldispatch : "") + "/img/fontawesome5/" + namesvg + ".svg";
        } else { return svgFontAwesomeData64[namesvg + "_" + size.toString()] }
    }

    this.mImgUrltoData64 = function (src, funcOk, funcKo, outputFormat, first) {
        var htmlImg = $("<img/>")
        htmlImg[0].crossOrigin = 'Anonymous';
        htmlImg.on("load", function () {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var dataURL;
            canvas.height = this.naturalHeight;
            canvas.width = this.naturalWidth;
            ctx.drawImage(this, 0, 0);
            dataURL = canvas.toDataURL(outputFormat);
            funcOk(dataURL);
        })
        htmlImg.on("error", function (e) {
            //on a pas pu récupérer l'image
            //c'est qu'elle sur un autre domaine
            //on la copie dans un répertoire temporaire sur le serveur
            //on traite cette image temporaire
            if (typeof first == 'undefined' || first) {
                bddRef.mAjaxCall({
                    command: "copyimagefromurl",
                    url: src
                }, function (data) {
                    if (typeof data.src == 'undefined') {
                        if (typeof funcKo != 'undefined' && funcKo != null) funcKo()
                    } else {
                        Me.mImgUrltoData64(document.URLRacine + data.src, funcOk, null, outputFormat, false)
                    }
                }, null, function (data) {
                    if (typeof funcKo != 'undefined' && funcKo != null) funcKo()
                })
            } else { if (typeof funcKo != 'undefined' && funcKo != null) funcKo() }
        })
        htmlImg[0].src = ((src.startsWith("//")) ? src.substring(1) : src);
    }

    this.mGetDataBase64FromImgBalise = function (baliseImg, src, funcOk) {
        baliseImg[0].crossOrigin = 'Anonymous';
        baliseImg.on("load", function () {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var dataURL;
            canvas.height = this.naturalHeight;
            canvas.width = this.naturalWidth;
            ctx.drawImage(this, 0, 0);
            dataURL = canvas.toDataURL();
            funcOk(dataURL);
        })
        baliseImg.on("error", function (ev) {
            funcOk("");
        })
        baliseImg[0].src = src
    }

    this.mResizeImage = function (urlImg, scale, callback, outputFormat) {
        if (typeof outputFormat == 'undefined') outputFormat = "image/png"
        var img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");

            canvas.width = this.naturalWidth * scale;
            canvas.height = this.naturalHeight * scale;
            ctx.drawImage(img, 0, 0, this.naturalWidth, this.naturalHeight, 0, 0, this.naturalWidth * scale, this.naturalHeight * scale);

            var dataURL = canvas.toDataURL(outputFormat);

            callback(dataURL);
        };
        img.src = urlImg;
    }

    this.mRotate = function (dataUrl, angle, funcOk) {
        var canvas = document.createElement('canvas');
        var img = new Image()
        img.onload = function () {
            //canvas must be squared and take the bigger size width or height
            var cnvsSize;
            if (img.naturalWidth > img.naturalHeight) {
                cnvsSize = img.naturalWidth;
                isHorizontal = true;
            }
            else {
                cnvsSize = img.naturalHeight;
                isHorizontal = false;
            }
            canvas.width = cnvsSize;
            canvas.height = cnvsSize;

            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            //go to the center of the canvas and rotate
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(angle * Math.PI / 180);

            //default x and y to draw
            var Y = -cnvsSize / 2;
            var X = -cnvsSize / 2;

            //calculate the x and y for the image to be drawn
            if (isHorizontal) {
                Y = (- img.naturalHeight) / 2;
            }
            else {
                X = (- img.naturalWidth) / 2;
            }

            ctx.drawImage(img, X, Y);

            //a temporary squared image
            var imgSquared = new Image();

            //take the data of the squared image
            imgSquared.src = canvas.toDataURL("image/jpg");


            imgSquared.onload = function () {

                //resize the canvas to the oposite to the original image
                canvas.width = img.naturalHeight;
                canvas.height = img.naturalWidth;

                //source is my squared image
                if (isHorizontal) {
                    var sourceX = (cnvsSize - canvas.width) / 2;
                    var sourceY = 0;
                }
                else {
                    var sourceX = 0;
                    var sourceY = (cnvsSize - canvas.height) / 2;
                }

                var sourceWidth = canvas.width;
                var sourceHeight = canvas.height;

                //destination is canvas resized
                var destX = 0;
                var destY = 0;
                var destWidth = canvas.width;
                var destHeight = canvas.height;

                ctx.clearRect(0, 0, canvas.width, canvas.height);

                ctx.drawImage(imgSquared, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight);

                imgSquared = null;

                funcOk(canvas.toDataURL())
            };
        }
        img.src = dataUrl;

    }

    // color sous la forme {R,G,B}
    this.mReplaceColorToTransparent = function (dataUrl, oldColor, funcOk) {
        var $ImgBase = $("<img style='position:absolute;top:-10000px;left:-10000px;'/>").appendTo("body")
        var originalPixels = null;
        var currentPixels = null;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        $ImgBase.on("load", function () {
            getPixels($ImgBase[0])
        })
        $ImgBase[0].src = dataUrl

        function getPixels(img) {
            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, img.width, img.height);
            originalPixels = ctx.getImageData(0, 0, img.width, img.height);
            currentPixels = ctx.getImageData(0, 0, img.width, img.height);

            changeColor()

            img.onload = null;
        }

        function hexToRGB(hex) {
            var long = parseInt(hex.replace(/^#/, ""), 16);
            return {
                R: (long >>> 16) & 0xff,
                G: (long >>> 8) & 0xff,
                B: long & 0xff
            };
        }

        function changeColor() {
            if (!originalPixels) return; // Check if image has loaded

            for (var I = 0, L = originalPixels.data.length; I < L; I += 4) {
                if (currentPixels.data[I] == oldColor.R && currentPixels.data[I + 1] == oldColor.G && currentPixels.data[I + 2] == oldColor.B) {
                    currentPixels.data[I + 3] = 0
                }
            }

            ctx.putImageData(currentPixels, 0, 0);
            funcOk(canvas.toDataURL("image/png"))
            $ImgBase.remove()
            $(canvas).remove();
        }
    }

    this.mGetDataUrlSurHandler = function (height_redimensionne, url, func) {
        option.bddCtrl.mAjaxCall({
            command: "getimageredimensionne",
            url: url,
            height_redimensionne: height_redimensionne
        }, function (data) {
            func(data.base64)
        })
    }

    this.mCopyImageInternetOnServeur = function (url, funcOk, funcKo) {
        bddRef.mAjaxCall({
            command: "copyimagefromurl",
            url: url
        }, function (data) {
            if (typeof data.src == 'undefined') {
                if (typeof funcKo != 'undefined') funcKo()
            } else {
                funcOk(document.URLRacine + data.src)
            }
        }, null, function (data) {
            if (typeof funcKo != 'undefined') funcKo()
        })
    }

    this.mGetImageFromHtml = function ($ele, funcOk, compression, format) {
        if (typeof compression == 'undefined') compression = 1
        if (typeof format == 'undefined') format = "image/png"
        html2canvas($ele[0], {
            useCORS: true,
            backgroundColor: null,
            removeContainer: true // ← nettoie les DOM clonés automatiquement
        }).then(function (canvas) {
            document.querySelectorAll('[data-html2canvas-ignore-clone], .html2canvas-container')
                .forEach(el => el.remove());

            funcOk(canvas.toDataURL(format, compression))
            console.log("📸 CAPTURE IMAGE")
        });
    }

    this.mGetImageFromHtmlAsync = async function ($ele, compression = 1, format = "image/png") {
        const canvas = await html2canvas($ele[0], {
            useCORS: true,
            backgroundColor: null,
            removeContainer: true
        });
        document.querySelectorAll('[data-html2canvas-ignore-clone], .html2canvas-container')
            .forEach(el => el.remove());
        console.log("📸 CAPTURE IMAGE");
        return canvas.toDataURL(format, compression);
    }

}